import * as React from "react";
type Props = {
  className?: string,
};
function SvgGrill({ className }: Props) {
  return (
    <svg
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="illustrated-Grill"
      className={className}
    >
      <path
        d="M32.9559 16.9339C32.9559 15.2922 27.1176 13.9617 19.9157 13.9617C12.7133 13.9617 6.875 15.2922 6.875 16.9339M32.9559 16.9339C32.9559 17.1295 32.8676 17.3206 32.7088 17.5061C32.7088 17.5061 32.853 27.5219 19.8713 27.5219C6.89342 27.5219 7.12205 17.5061 7.12205 17.5061C6.96328 17.3206 6.875 17.1295 6.875 16.9339M32.9559 16.9339C32.9559 18.5756 27.1176 19.906 19.9157 19.906C12.7133 19.906 6.875 18.5756 6.875 16.9339M9.73801 14.9604L14.684 19.512M14.8711 14.1049L20.9634 19.8022M20.1012 14.1049L25.8233 19.432M24.6802 26.6258L27.3361 34.2798M16.3188 26.9684L13.6629 34.6224M20.4451 27.6986V39.5904M25.8212 14.383L30.4707 18.6374M20.6738 0.625C20.6738 2.22032 19.4036 2.22032 19.4036 3.81628C19.4036 5.41287 20.6738 5.41287 20.6738 7.00947C20.6738 8.60606 19.4036 8.60606 19.4036 10.2027M24.7619 1.59051C24.7619 3.18584 23.4917 3.18584 23.4917 4.78179C23.4917 6.37839 24.7619 6.37839 24.7619 7.97498C24.7619 9.57157 23.4917 9.57157 23.4917 11.1682M16.4012 1.79507C16.4012 3.3904 15.131 3.3904 15.131 4.98635C15.131 6.58295 16.4012 6.58295 16.4012 8.17954C16.4012 9.77613 15.131 9.77613 15.131 11.3727"
        stroke="#303E5C"
      />
    </svg>
  );
}
export default SvgGrill;
